function pad(num) {
  return num >= 10 ? num : `0${num}`;
}

export default (time, format = 'clock') => {
  const seconds = parseInt(time % 60, 10);
  const minutes = parseInt((time / 60) % 60, 10);
  const hours = parseInt(time / 3600, 10);

  if (format !== 'clock') {
    return `${hours > 0 ? `${pad(hours)}:` : ''}${pad(minutes)}:${pad(seconds)}`;
  }

  return `${hours > 0 ? `${hours}h` : ''} ${minutes}m ${seconds}s`;
};
